


























































import Vue from "vue"
import {DpdProduct} from "@/model/new-parcel-model/dpd-product/dpd-product"
import {CreateParcelModel} from "@/model/new-parcel-model/create-parcel-model"
import { DpdProductVariant } from "@/model/new-parcel-model/dpd-product/dpd-product-variant"
import { plainToClass } from "class-transformer"

interface Form {
  reference: string
}

export interface IColReqProductGroup extends Vue {
  form: Form

  clearAll(): void
}

export default Vue.extend({
  data() {
    return {
      form: {
        reference: ""
      },
      rules: {
        reference: [{
          required: true, message: this.$t("new_parcel.error.reference_mandatory").toString(),
          trigger: "change"
        }]
      }
    }
  },
  props: {
    createParcelModel: {
      type: CreateParcelModel,
      required: true
    },
    dpdProducts: {
      type: Array as () => DpdProduct[],
      required: true
    },
    productValidated: {
      type: Boolean,
      required: true
    },
    hasProductVariant: {
      type: Boolean,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    parcelPcs: {
      type: String
    }
  },
  methods: {
    clearAll() {
      this.form.reference = ""
    },
    async changeProduct(dpdProduct: DpdProduct) {
      const vm = this
      const countryId = this.$store.state.authenticatedEmployee.office.country.id
      await this.$http.get(`/product/employee_product_variant/${dpdProduct.type}/${countryId}`).then(res => {
        vm.createParcelModel.dpdProductVariants = plainToClass(DpdProductVariant, res.data)
        vm.createParcelModel.dpdProduct = dpdProduct
        vm.createParcelModel.consolidateVariantFromContext()
      })
      this.createParcelModel.dpdProduct = dpdProduct
      this.$forceUpdate()
    },
    emitValidation() {
      this.$emit(
        "update:productValidated",
        !this.createParcelModel.createParcelModelOptions.returnOfDocument.value ||
        (exists(this.form.reference) &&
          this.form.reference !== "" &&
          this.createParcelModel.createParcelModelOptions.returnOfDocument.value)
      )
    }
  },
  computed: {
    availableDpdProducts(): DpdProduct[] {
      return this.dpdProducts
    }
  },
  watch: {
    "form.reference": {
      handler() {
        this.emitValidation()
      }
    },
    "createParcelModel.createParcelModelOptions.returnOfDocument.value": {
      handler() {
        this.emitValidation()
      }
    }
  }
})
